<template>
  <div id="app">
    <Header @showTerms="showTermsComponent" @newKit="newKit"></Header>
    <img
      class="got-mold-box registration-box"
      src="./images/bg/bg_box.png"
      alt="Box"
      v-if="
        this.$route.name === 'GetStarted' ||
          this.$route.name === 'Login' ||
          this.$route.name === 'Registration' ||
          this.$route.name === 'Resetpassword' ||
          this.$route.name === 'RegesterAdmin'
      "
    />
    <img
      src="./images/bg/spinner.png"
      alt="Spinner"
      class="spinner"
      v-if="
        this.$route.name === 'GetStarted' ||
          this.$route.name === 'Login' ||
          this.$route.name === 'Registration' ||
          this.$route.name === 'Resetpassword'
      "
    />
    <transition name="router-anim">
      <router-view
        :showCustomerProfile="showCustomerProfile"
        :newKitModal="newKitModal"
        @showProfile="showProfile"
        @resetModal="resetModal"
        @closeProfile="closeProfile"
        @showTerms="showTermsComponent"
        @showPrivecy="showPrivecyComponent"
      ></router-view>
    </transition>
    <Privacy v-if="showPrivecy" @showPrivecy="showPrivecyComponent"></Privacy>
    <Terms v-if="showTerms" @showTerms="showTermsComponent"></Terms>
    <Footer @showPrivecy="showPrivecyComponent"></Footer>
  </div>
</template>

<script>
import Header from "./components/shared/Header";
import Footer from "./components/shared/Footer";
import Privacy from "./components/shared/Privacy";
import Terms from "./components/shared/terms";

export default {
  name: "app",
  data() {
    return {
      showCustomerProfile: false,
      newKitModal: {},
      showPrivecy: false,
      showTerms: false
    };
  },
  components: {
    Header,
    Footer,
    Privacy,
    Terms
  },
  methods: {
    showPrivecyComponent(boolean) {
      this.showPrivecy = boolean;
    },
    showTermsComponent(boolean) {
      this.showTerms = boolean;
    },
    showProfile(boolean) {
      this.showCustomerProfile = boolean;
    },
    newKit(obj) {
      this.newKitModal = obj;
    },
    resetModal(obj) {
      this.newKitModal = obj;
    },
    closeProfile(boolean) {
      this.showCustomerProfile = boolean;
    }
  }
};
</script>

<style lang="scss">
@import "./styles/reset.css";
@import "./styles/fonts.css";
@import "./styles/_colors.scss";
.router-anim-enter-active {
  animation: coming 0.6s;
  animation-delay: 0.5s;
  opacity: 0;
}
.router-anim-leave-active {
  animation: going 0.4s;
}
.spinner {
  position: absolute;
  top: 130px;
  left: 60px;
  width: 68px;
  z-index: 4;
}
@keyframes going {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-20px);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateX(-20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
input.toLowerCase {
  text-transform: lowercase;
}
input.toLowerCase::placeholder {
  text-transform: capitalize;
}
.remove-icon {
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s linear;
}
.container {
  max-width: 1190px;
  width: 100%;
  margin: 0 auto;
  position: relative;
}
.got-mold-box {
  position: absolute;
  width: 95vw;
  top: 180px;
}
.kits-item:hover .remove-icon {
  visibility: visible;
  opacity: 1;
}
.input-wrap {
  position: relative;
}
.validate-error {
  color: $red;
  font-size: 13px;
  font-family: TTNormsLight, sans-serif;
  position: absolute;
  bottom: -15px;
  display: inline-block;
  left: 0;
  width: 100%;
  text-align: center;
}
.validate-error.right {
  text-align: right;
}
.validate-error.password {
  width: 312px;
}
.validate-error.zip {
  /*width: 131%;*/
  /*text-align: left;*/
}
.validate-error.twilio {
  /*bottom: -30px;*/
}
#app {
  position: relative;
  background: url("./images/bg/bg_clouds.png") 0 100px no-repeat;
}
.datepickerWrap .datepickerInput {
  padding: 15px 20px;
  color: $gray;
  border-radius: 10px;
  width: 100%;
  font-size: 16px;
  text-align: center;
  border: 1px solid #ccc;
  font-family: TTNormsMedium, sans-serif;
  outline: none;
}
.datepickerWrap .datepickerInput::placeholder {
  color: $lightGray;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
}
.datepickerWrap .datepickerInput.error {
  border: 1px solid $red;
}
.datepickerWrap .datepickerInput.error:focus {
  border: 1px solid rgb(77, 144, 254);
}
.datepickerWrap {
  margin: 0 0 20px 0;
}
.datepickerWrapAdmin {
  margin: 0px 0 0 10px;
}
.datepickerInputAdmin {
  padding: 10px 30px 9px 30px;
  max-width: 130px;
  outline: none;
  border-radius: 3px;
  cursor: pointer;
  border: none;
  font-size: 10px;
}

.datepickerInputAdmins {
  padding: 10px 30px 9px 30px;
  outline: none;
  border-radius: 3px;
  cursor: pointer;
  border: none;
  font-size: 10px;
  width: 95%;
  text-align: center;
  color: #98a4ae;
  font-size: 14px;
  text-transform: capitalize;
  font-family: TTNormsLight, sans-serif;
}
.calendarWrap span {
  font-family: TTNormsLight, sans-serif;
}
.calendarWrap {
  left: 50%;
  transform: translate(-50%);
  border: 1px solid $lightGray;
  border-radius: 5px;
}
.pogination-wrap {
  display: flex;
  color: $gray;
  justify-content: center;
  font-family: TTNormsRegular, sans-serif;
  font-size: 14px;
}
.pogination-item {
  margin: 0 5px;
  outline: none;
}
.pogination-item a {
  outline: none;
}
.pogination-item.active {
  color: $blue;
}
.validate-error.oldPass {
  font-size: 11px;
}
@media (max-width: 1200px) {
  .container {
    max-width: calc(100% - 40px);
  }
}
@media (max-width: 768px) {
  .got-mold-box {
    display: none;
  }
  .spinner {
    display: none;
  }
}
</style>
